export const VEHICLE_COLOR_OPTIONS = ["Red", "Green", "Blue", "Yellow", "Black", "White", "Gray", "Orange", "Brown"];

export const VEHICLE_MAKE_OPTIONS = [
    // Most common (alphabetical)
    "Acura",
    "Audi",
    "BMW",
    "Buick",
    "Cadillac",
    "Chevrolet",
    "Chrysler",
    "Dodge",
    "Ford",
    "Genesis",
    "GMC",
    "Honda",
    "Hyundai",
    "Infiniti",
    "Jaguar",
    "Jeep",
    "Kia",
    "Land Rover",
    "Lincoln",
    "Lexus",
    "Mazda",
    "Mercedes",
    "Mini",
    "Mitsubishi",
    "Nissan",
    "Porsche",
    "Smart Car",
    "Subaru",
    "Tesla",
    "Toyota",
    "Volkswagen",
    "Volvo",

    // Less common/exotic (alphabetical)
    "Alfa Romeo",
    "Aston Martin",
    "Bentley",
    "Bugatti",
    "Citroen",
    "Ferrari",
    "Fiat",
    "Giant Truck",
    "Lamborghini",
    "Maserati",
    "McLaren",
    "Pagani",
    "Peugeot",
    "Renault",
    "Rolls-Royce",
    "Saab",
    "Suzuki",
];
